import { createContext, useContext } from 'react';

import { DEFAULT_COLOR_SCHEME } from './constants';
import { ColorSchemeType } from './types';

const ColorSchemeContext = createContext<ColorSchemeType>(DEFAULT_COLOR_SCHEME);

export const ColorSchemeProvider = ColorSchemeContext.Provider;
export const ColorSchemeConsumer = ColorSchemeContext.Consumer;

export const useColorScheme = () => useContext(ColorSchemeContext);
